/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 21:00:07 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 10:50:32
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.earningBrb.h1') }}</h1>
      <h2>{{ st('helpDocs.earningBrb.h2What') }}</h2>
      <p>{{ st('helpDocs.earningBrb.pWhat1') }}</p>
      <p>{{ st('helpDocs.earningBrb.pWhat2') }}</p>
      <h2>{{ st('helpDocs.earningBrb.h2Qualify') }}</h2>
      <p>{{ st('helpDocs.earningBrb.pQualifyIntro') }}</p>
      <ul>
        <li>{{ st('helpDocs.earningBrb.liQ1') }}</li>
        <li>{{ st('helpDocs.earningBrb.liQ2') }}</li>
        <li>{{ st('helpDocs.earningBrb.liQ3') }}</li>
        <li>{{ st('helpDocs.earningBrb.liQ4') }}</li>
      </ul>
      <p>
        {{ st('helpDocs.earningBrb.pMore') }}
        <a
          href="https://sellercentral.amazon.com/help/hub/reference/external/GL9HPJ34VBFP76HX?initialSessionID=apay%3D147-0673581-9434758&ld=NSGoogle"
          target="_blank"
          >{{ st('helpDocs.earningBrb.aSellerCentral') }}</a
        >.
      </p>
      <img
        src="about-artemisads/earning-amazon-brand-referral-bonus.png"
        :alt="st('helpDocs.earningBrb.imgAlt')"
      />
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
